module.exports = __webpack_public_path__ + "static/media/massi.c183caac.JPG";